"use client";
import { CustomGrid } from "@/components/layout/grid";
import { RichTextComponent } from "@/components/molecules/richTextComponent";
import { GridItem } from "@chakra-ui/react";

interface RichTextBlockProps {
  title?: string;
  subTitle?: string;
  markup?: string;
  fullWidth?: boolean;
  fundsDetailPage?: boolean;
}

export const RichTextBlock = ({
  title,
  subTitle,
  markup,
  fullWidth = false,
  fundsDetailPage = false,
}: RichTextBlockProps) => {
  const colStart = fundsDetailPage
    ? { base: 1, md: 1, lg: 1 }
    : { base: 1, md: 3, lg: 4 };

  const colSpan = fundsDetailPage
    ? { base: 12, md: 12, lg: 12 }
    : { base: 12, md: 8, lg: 6 };

  return (
    <CustomGrid
      maxW={fundsDetailPage && !fullWidth ? "contentmodule" : "none"}
      py={{
        base: fundsDetailPage ? 0 : 6,
        md: fundsDetailPage ? 0 : 9,
      }}
      px={{
        base: fundsDetailPage ? 0 : 4,
        md: fundsDetailPage ? 0 : 9,
      }}
    >
      <GridItem colStart={colStart} colSpan={colSpan}>
        <RichTextComponent title={title} subTitle={subTitle} markup={markup} />
      </GridItem>
    </CustomGrid>
  );
};
